<template>
  <div class="row">
    <div class="col-lg-6" v-if="data.activitiesSector && Object.keys(data.activitiesSector).length">
      <p class="fw-bold textStyle">{{ $t("training.rncp.business_sectors") }}</p>
      <p v-for="activitySector in data.activitiesSector" :key="activitySector.title">{{ activitySector.title }}</p>
    </div>

    <div class="col-lg-6" v-if="data.employmentTypes && Object.keys(data.employmentTypes).length">
      <p class="fw-bold textStyle">{{ $t("training.rncp.types_of_jobs") }}</p>
      <p v-for="employmentType in data.employmentTypes" :key="employmentType.title">{{ employmentType.title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingRncpAccordionSectorsComponent",
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  line-height: 2;
  @include dark-theme {
    color: $m_color_1;
  }
}
</style>
